import styled from 'styled-components'

export const Container = styled.div`
  /* position: relative; */
  display: flex;
  flex-direction: column;
  max-width: 100%;
  .transferir-title {
    color: var(--Preto-Principal, #1c1d22);
    font-family: Inter;
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }

  .transferir-title span {
    font-weight: 700;
  }

  .transferir-cards-container {
    display: flex;

    margin: 32px 0px 40px 1px;

    gap: 16px;
  }

  .transferir-container {
    display: flex;
    flex-direction: column;

    gap: 40px;
  }

  .transferir-form-container {
    display: flex;
    position: relative;
    gap: 20px;
    flex-wrap: wrap;
    margin-bottom: 14px;
    margin-top: 40px;
  }

  .depositar-table-container {
    display: flex;
    flex-direction: column;

    border-top: 0.5px solid #eee;
    padding-top: 40px;

    gap: 32px;
  }

  .depositar-table-title {
    color: #000;

    font-family: 'Inter';
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }

  .transferir-details-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding-bottom: 32px;
  }

  .transferir-text1 {
    color: var(--Preto-Principal, #1c1d22);
    font-feature-settings: 'clig' off, 'liga' off;
    font-family: 'Inter';
    font-size: 15px;
    font-style: normal;
    font-weight: 300;
    line-height: 32px; /* 200% */
  }

  .transferir-text2 {
    color: var(--Preto, #070707);
    /* Inter/Headind/H2 20px Medium */
    font-family: 'Inter';
    font-size: 15x;
    font-style: normal;
    font-weight: 500;
    line-height: normal;

    margin-bottom: 24px;
  }

  .transferir-value {
    color: #00cd52;
    font-feature-settings: 'clig' off, 'liga' off;
    font-family: 'Inter';
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: 32px;

    margin-bottom: 24px;
  }

  .transferir-info-banco {
    margin: 16px 0px 24px 0px;
    width: 315px;
    border-radius: 5px;
    border: 1px solid var(--Cinza-Cinza-claro---C, rgba(204, 204, 204, 0.8));
    padding: 0px 16px;
  }

  .transferir-info-banco-col1 {
    display: flex;
    justify-content: space-between;

    padding: 16px 0px;

    border-bottom: 0.5px solid #eee;
  }

  .transferir-info-banco-col1 button {
    border: none;
    background-color: transparent;

    color: #df7a58;
    font-family: Inter;
    font-size: 12px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }

  .transferir-info-banco-pixInfo {
    display: flex;
    flex-direction: column;

    gap: 4px;
  }

  .transferir-info-banco-pixInfo-text1 {
    color: var(--Cinza-Cinza---75, #757575);
    /* Inter/Detalhes/12px Regular */
    font-family: 'Inter';
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }

  .transferir-info-banco-pixInfo-text2 {
    color: var(--Preto, #070707);
    /* Inter/Detalhes/14px Bold */
    font-family: 'Inter';
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }

  .transferir-info-banco2 {
    display: flex;
    flex-direction: column;
    margin: 16px 0px 24px 0px;
    width: 315px;
    border-radius: 5px;
    border: 1px solid var(--Cinza-Cinza-claro---C, rgba(204, 204, 204, 0.8));
    padding: 16px;
    gap: 4px;
  }
`
export const Erro = styled.p`
  color: #ff0000;
  position: absolute;
  bottom: -6px;
  font-size: 12px;
  width: 100%;
  font-weight: 500;
`
